import firebase from 'firebase'
import 'firebase/firestore'
import store from "./store/store";
import api from './api';
import db from "./firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC4qZMJM1-ZHPVnrYiQZy3ttPmGEy8-Dz8",
  authDomain: "idea-mng.firebaseapp.com",
  databaseURL: "https://idea-mng.firebaseio.com",
  projectId: "idea-mng",
  storageBucket: "idea-mng.appspot.com",
  messagingSenderId: "83554602806",
  appId: "1:83554602806:web:55adfb881bc1950f832d97",
}

const firebaseApp = firebase.initializeApp(firebaseConfig)

firebase.getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      unsubscribe();
      resolve(user);
    }, reject);
  })
};

firebase.auth().onAuthStateChanged(async user => {
  if (user) {
    if (!localStorage.getItem('signup-in-progress')) {
      await api.afterLoginSetup(user);
    } else {
      db.collection("metadata")
        .doc(user.uid)
        .onSnapshot(async (snap) => {
          if (!snap.data()) return;
          api.createUserProfile(user, null, null);
        });
    }
  } else {
    store.dispatch("fetchLogoutSetup");
  }
});

export default firebaseApp
